import { Messages } from "../../lib/locale";

export const German: Messages = {
  name: "Deutsch",
  helpTitle: "Spielanleitung?",
  help1: `Ihre Aufgabe ist es, herauszufinden, welches Land im Spiel versteckt ist. Dazu müssen Sie die Namen zufälliger Länder eingeben. Schreiben Sie das Land in das Eingabefeld und drücken Sie die Eingabetaste. Dieses Land wird auf der Karte erscheinen und seine Farbe ändern, je nachdem, wie nahe es dem versteckten Land ist. Je dunkler die Farbe, desto näher sind Sie der Antwort!`,
  help2: `Sehen Sie sich das Spielbeispiel an. Nehmen wir an, das Land Japan ist im Spiel versteckt. Dann werden diese Länder in solchen Farben gemalt.`,
  help3: `Einmal am Tag ist ein neues verstecktes Land verfügbar. Oder wechseln Sie in den Einstellungen in den kostenlosen Modus und spielen Sie unbegrenzt.`,
  France: "Frankreich",
  Nepal: "Nepal",
  Mongolia: "Mongolei",
  "South Korea": "Südkorea",
  Aux1: `<b>["Klicken", "Tippen"]</b> Sie auf den Globus, um zu beginnen!`,
  Loading: "Warte darauf...",
  GameTitle: "Spiel",
  Game1: "Geben Sie hier den Ländernamen ein",
  Game2: "Eingeben",
  Game3: "Gib hier den Namen des Landes ein um zu beginnen.",
  Game4: `Drehen, <span>["klicken", "berühren"]</span> und zoomen Sie den Globus, um das nächste Land zu finden, das Sie erraten können`,
  Game5: "Wir kennen dieses Land nicht",
  Game6: "Dieses Land wurde bereits verwendet",
  Game7: "Das verborgene Land war {answer}!",
  Game8: "Nächste Grenze",
  StatsTitle: "Statistiken",
  Stats1: "Letzter Sieg",
  Stats2: "Heutige Versuche",
  Stats3: "Gewonnene Spiele",
  Stats4: "Aktueller Streifzug",
  Stats5: "Maximaler Streifen",
  Stats6: "Durchschnittliche Versuche",
  Stats7: "Ø. Versuche",
  Stats8: "Zurücksetzen",
  Stats9: "Teilen",
  Stats10: "Bist du dir sicher, dass du deine Statistiken löschen möchtest?",
  Stats11: "Statistiken gelöscht.",
  Stats12: "In die Zwischenablage kopiert!",
  SettingsTitle: "Einstellungen",
  Settings1: "Tag Theme",
  Settings2: "Nacht Theme",
  Settings3: "Kontrastfarben",
  Settings4: "Kontrastfarben",
  Settings5: "Länder",
  Settings7: "Sprache",
  Settings9: "Freier Modus",
  Settings10: "Schritten",
  Answer: "Antworten",
  Closest: "Am nächsten",
  Guessed: "Erraten",
  PracticeMode: "Sie befinden sich im kostenlosen Modus.",
  PracticeExit: "Beenden Sie den freien Modus",
  PracticeNew: "Neues freien Spiel",
  PlayAgain: "Nochmal abspielen",
  SortBy: "Sortieren nach:",
  SortByGuesses: "Schätzreihenfolge",
  SortByDistance: "Entfernung",
  Clipboard: "🌍🌍🌍\nIch habe das verborgene Land im heutigen Globle in {X} Versuchen erraten.\nKannst du es besser?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Sieg",
  Guesses: "Vermutungen",
  GuessesFlags: "Ihre Vermutungen",
  Daily: "Täglich",
  NextDailyIn: "Nächstes Spiel",
  Learn: "Lernen Sie dieses Land kennen"
};